export const PATHS = {
  Login: "login",
  VenueLogin: "venue-login",
  EventList: "events",
  Main: "events/:eventOccurrenceId",
  EventTab: "/",
  EventDetails: "/",
  TicketList: "tickets",
  Cart: "cart",
  Billing: "billing",
  Checkout: "checkout",
  Payment: "payment",
  OrderDetails: "orders/:orderId",
  TicketDetails: "events/:eventOccurrenceId/tickets/:ticketId",
  ScannerTab: "scanner",
  Scanner: "/",
  SettingsTab: "settings",
  Settings: "/",
  TerminalSettings: "terminal",
  VenueSettings: "venue",
} as const;

export const SCREENS = Object.keys(PATHS).reduce(
  (screens, key) => ({
    ...screens,
    [key]: key,
  }),
  {} as { [TKey in keyof typeof PATHS]: TKey }
);
